import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TenantsDTO, TenantsFilters } from '../../models/tenants';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';


@Injectable({
  providedIn: 'root',
})
export class LaravelTenantService {
  constructor(private httpClient: HttpClient) {}

  private get ROUTES() {
    return {
      list: environment.baseUrl + '/api/tenants',
      show: environment.baseUrl + '/api/tenants',
      store: environment.baseUrl + '/api/tenants',
      destroy: environment.baseUrl + '/api/tenants',
    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: TenantsFilters,
    includes?: string[]
  ): Observable<ListResultDTO<TenantsDTO>> {
    let params = {};
    if (order) params['order'] = '' + order;
    if (direction) params['direction'] = '' + direction;
    if (includes) params['includes[]'] = includes;
    if (filters) {
      if (filters.search) params['search'] = filters.search;
    }
    if (per_page) {
      params['per_page'] = '' + per_page;
      if (page) params['page'] = '' + page;
      return this.httpClient.get<ListResultDTO<TenantsDTO>>(
        this.ROUTES.list,
        {
          params: new HttpParams({ fromObject: params }),
        }
      );
    } else {
      return this.httpClient
        .get<TenantsDTO[]>(this.ROUTES.list, {
          params: new HttpParams({ fromObject: params }),
        })
        .pipe(
          map((results) => {
            return {
              data: results,
              total: results.length,
            };
          })
        );
    }
  }

  public show(id: number): Observable<TenantsDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<TenantsDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params,
      }),
    });
  }

  public upsert(tenant: TenantsDTO): Observable<TenantsDTO> {
    if (tenant.id) {
      return this.httpClient.put<TenantsDTO>(`${this.ROUTES.store}/${tenant.id}`, {
        ...tenant,
      });
    } else {
      return this.httpClient.post<TenantsDTO>(`${this.ROUTES.store}`, {
        ...tenant,
      });
    }
  }

  public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
  }
}
